import PropTypes from 'prop-types';
import { useEffect, useRef } from 'react';
import ReactNotification from 'react-notifications-component';
import { Provider } from 'react-redux';
import { BrowserRouter as Router } from 'react-router-dom';
import uuid from 'react-uuid';

import AppContext from '../../../context/AppContext';
import ErrorBoundary from './components/container/ErrorBoundary';
import FormTemplateContainer from './components/container/FormTemplateContainer';
import Sidebar from './components/presentational/sidebar/Sidebar';
import * as formTemplateApiActions from './redux/actions/formTemplateApiActions';
import { setInternalSettings } from './redux/actions/internal/internalCreators';
import store from './redux/store';

export function FormTemplates(props) {
  const { account, planOptions, accountTimezone, authenticityToken } = props;

  const notificationDomRef = useRef(null);

  useEffect(() => {
    const internalValues = {
      authenticityToken: authenticityToken,
      accountId: account.id,
      accountTimezone: accountTimezone,
      planOptions: planOptions,
    };

    store.dispatch(setInternalSettings(internalValues));
  }, []);

  useEffect(() => {
    if (account.id !== undefined) {
      store.dispatch(formTemplateApiActions.fetchFormTemplates());
    }
  }, []);

  return (
    <Provider store={store}>
      <Router basename="administration/form_templates">
        <ErrorBoundary authenticityToken={authenticityToken} errorRef={uuid()}>
          <div id="modal-root" />
          <ReactNotification ref={notificationDomRef} />
          <div className="template-builder_container">
            <Sidebar />
            <div className="template-builder_content-container">
              <AppContext.Provider value={{ notificationDomRef }}>
                <FormTemplateContainer />
              </AppContext.Provider>
            </div>
          </div>
        </ErrorBoundary>
      </Router>
    </Provider>
  );
}

FormTemplates.propTypes = {
  account: PropTypes.shape().isRequired,
  planOptions: PropTypes.shape().isRequired,
  accountTimezone: PropTypes.string.isRequired,
  authenticityToken: PropTypes.string.isRequired,
};

export default FormTemplates;
